import { render, staticRenderFns } from "./RewardsListItem.vue?vue&type=template&id=b9249960&"
import script from "./RewardsListItem.vue?vue&type=script&lang=js&"
export * from "./RewardsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports